<template>
  <div>
    <div v-html="content"/>
  </div>
</template>

<script>
import axios from 'axios'
import MarkdownIt from 'markdown-it';
import MIAttrs from 'markdown-it-attrs';
import MIReplaceLink from 'markdown-it-replace-link';

import hljs from 'highlight.js/lib/highlight';
import sql from 'highlight.js/lib/languages/sql';
import shell from 'highlight.js/lib/languages/shell';
import java from 'highlight.js/lib/languages/java';
import python from 'highlight.js/lib/languages/python';
hljs.registerLanguage('sql', sql);
hljs.registerLanguage('shell', shell);
hljs.registerLanguage('java', java);
hljs.registerLanguage('python', python);

export default {
  name: 'Markdown',
  data() {
    return {
      content: null
    };
  },
  mounted() {
    this.content = null;
    const url = 'markdown/' + this.$route.params.folder + "/" + this.$route.params.name + "/"+ this.$route.params.name + ".md";
    axios.get(url)
      .then(response => {
        var md = new MarkdownIt({
          highlight: (str) => {
            try {
              return hljs.highlightAuto(str).value;
            } catch (__) {
              return '';
            }
          },
          // kludge to redirect links to static assets, internal links
          replaceLink: (link) => {
            if (!(link.includes('://'))) {
              return 'markdown/' + this.$route.params.folder + '/' + this.$route.params.name + '/' + link;
            }
            return link;
          }
        });
        md.use(MIReplaceLink);
        md.use(MIAttrs);

        this.content = md.render(response.data);
      })
      .catch(error => {
        this.content = "<h2>" + error + "</h2>";
      });
  }
}
</script>